import React from 'react';
import { InvalidIdpUser } from '../components/InvalidIdpUser';

export const InvalidIdpUserRoute = () => <InvalidIdpUser />;
